const timerMixin = {
  data: () => ({
    now: null,
    nowMinuteDelay: null,
    autoRefresh: true,
    currentInterval: null,
    currentIntervalMinuteDelay: null
  }),
  computed: {
    // property that should be used in computed prop to calculate the time left
    currentDateTime () {
      return this.now
    },

    currentDateTimeMinuteDelay () {
      return this.nowMinuteDelay
    }
  },
  methods: {
    createTimeInterval () {
      return setInterval(() => {
        this.now = Date.now()
      }, 1000)
    },

    createMinuteTimeInterval () {
      this.nowMinuteDelay = Date.now()
      return setInterval(() => {
        this.nowMinuteDelay = Date.now()
      }, 1000 * 60)
    }
  },
  created () {
    this.currentInterval = this.createTimeInterval()
    this.currentIntervalMinuteDelay = this.createMinuteTimeInterval()
  },
  beforeDestroy () {
    // clear interval before destroying component
    clearInterval(this.currentInterval)
    clearInterval(this.currentIntervalMinuteDelay)
  }
}

export default timerMixin
